import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext({ token: null, setToken: () => {} });

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  // Initial token state should check for both localStorage and the URL
  const getInitialToken = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get('accessToken');
    if (tokenFromUrl) {
      localStorage.setItem('accessToken', tokenFromUrl);
      window.history.replaceState(null, '', window.location.pathname); // Clean up URL
      return tokenFromUrl;
    }
    return localStorage.getItem('accessToken');
  };

  const [token, setToken] = useState(getInitialToken);

  useEffect(() => {
    // If no token is found, redirect to login
    if (!token) {
      navigate('/login');
    }
  }, [token, navigate]);

  useEffect(() => {
    // Update localStorage whenever the token changes
    if (token) {
      localStorage.setItem('accessToken', token);
      if (window.location.pathname === '/login') {
        navigate('/'); // Navigate to homepage if on login page and token is available
      }
    } else {
      localStorage.removeItem('accessToken');
      navigate('/login');
    }
  }, [token, navigate]);

  const handleLogout = () => {
    setToken(null);
    localStorage.removeItem('accessToken');
    navigate('/login'); // Redirect to login page
  };

  return (
    <AuthContext.Provider value={{ token, setToken, handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
